import { apiSlice } from './apiSlice';

export const sharedPlanApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // The Shared Plan page's view of a Plan, by its share token: no sign-in
    // needed.
    getSharedPlan: builder.query({
      query: (token) => ({
        url: `/shared-plans/${token}/`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetSharedPlanQuery } = sharedPlanApiSlice;
